import styled from "styled-components";
import { Modal } from "components/Modal";

export const StartStrategyModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 440px;
    min-width: 440px !important;
  }

  .heading {
    color: ${({ theme }) => theme.card.font.tertiary};
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    padding-top: 20px;
    margin-bottom: 0px;
  }
  &.modal-wrapper.stop-strategy-modal .modal-body {
    margin-top: 0px;
  }

  .modal-body .modal-heading {
    font-size: 22px;
    font-weight: 700;
  }

  .modal-dialog {
    min-width: 533px;

    .modal-content {
      padding: 30px;
      box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
      .modal-header {
        padding: 0;
        .modal-heading {
          text-align: center;
          margin: 0 auto;
          font-weight: 700;
          font-size: 28px;
          line-height: 130%;
          color: ${({ theme }) => theme.modal.subHeading.font.color};
        }
      }
      .modal-body {
        padding: 0;

        .heading {
          background-color: transparent;
          justify-content: center;
          color: ${({ theme }) => theme.card.font.tertiary};
          text-align: center;
          font-size: 20px;
          font-style: normal;
          font-weight: 500;
          padding-bottom: 14px;
        }
      }
    }
  }

  .strategy-modal-header {
    .heading {
      font-weight: 700;
      font-size: 23px;
      color: ${({ theme }) => theme.modal.heading.font.primary};
      text-align: center;
    }
    .sub-heading {
      padding-top: 20px;
      font-weight: 700;
      font-size: 16px;
      line-height: 130%;
      text-align: center;
      color: ${({ theme }) => theme.modal.subHeading.font.color};
    }

    .description {
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: ${({ theme }) => theme.card.font.tertiary};
      margin-bottom: 0px;
    }
  }

  .strategy-modal-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    gap: 16px;

    .start-btn,
    .stop-btn {
      padding: 3px 25px;
      width: 229px;
      height: 40px;
      background: ${({ theme }) => theme.button.bg.secondary};
      font-weight: 500;
      font-size: 14px;
    }

    .cancel-btn {
      padding: 3px 25px;
      width: 229px;
      height: 40px;
      font-weight: 500;
      font-size: 14px;
    }

    .start-btn {
      background: ${({ theme }) => theme.button.bg.primary};
    }

    .stop-btn {
      background-color: #ff3f3f;
    }
  }

  @media (max-width: 768px) {
    .modal-dialog {
      min-width: auto !important;

      .modal-content {
        padding: 30px 10px;
      }
    }

    .strategy-modal-footer {
      .start-btn,
      .cancel-btn,
      .stop-btn {
        padding: 0;
        width: 50%;
      }
    }
  }
`;
